import React, { useState } from 'react';
const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
      <div className="accordion-header" onClick={toggleAccordion}>
        <h4>{title}</h4>
        <span className="arrow">{isOpen ? '−' : '+'}</span>
      </div>
      {isOpen && <div className="accordion-content">{content}</div>}
    </div>
  );
};

const Accordion = ({ items }) => {
  const [isPromo, setIsPromo] = useState(false);
  // React.useEffect(() => {
  //   document.getElementsByClassName("Promo-Offtext").length > 0
  //     ? setIsPromo(true)
  //     : setIsPromo(false);
  // }, []);
  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      const exists =
        document.getElementsByClassName("Promo-Offtext").length > 0;
      setIsPromo(exists);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  })
    return (
      <div className='supTag'>
        {items.map((item, index) => (
          <AccordionItem key={index} title={item.title} content={item.content} />
        ))}
        <sup className="supText">
          * All pricing mentioned are in USD

        </sup>
        <sup className="supText">
          {isPromo
            ? "* This is a limited-time promo and can be withdrawn at any time without notice.  # Includes one free customization (up to 4 hours, worth $400)"
            : "# Includes one free customization (up to 4 hours, worth $400)"}

        </sup>
      </div>
    );
  };

  export default Accordion;
